import './App.css';
import './Media.css'
import './Styles.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Authentication/Login/Login';
import Header from './Components/Header/Header';
import Support from './Components/Support/Support';
import CreateUser from './Components/CreateUser/CreateUser';
import AllUser from './Components/AllUser/AllUser';
import Dashboard from './Components/Dashboard/Dashboard';
import consts from './constant';
import UserList from './Components/UserList/UserList';
import TradeHistory from './Components/TradeHistory/TradeHistory';
import P2pHistory from './Components/TradeHistory/P2pHistory';
import RaiseDispute from './Components/TradeHistory/RaiseDispute';
import DisputeDetails from './Components/TradeHistory/DisputeDetails ';
import Kyc from './Components/Kyc/Kyc';
import KycDetails from './Components/Kyc/KycDetails';
import UserWithdrawHistry from './Components/UserWithdrawHistry/UserWithdrawHistry';
import Asset from './Components/Asset/Asset';
import TradePair from './Components/TradePair/TradePair';
import P2pList from './Components/TradePair/P2pList';
import SubAdmin from './Components/SubAdmin/SubAdmin';
import CreateTradepair from './Components/TradePair/CreateTradepair';
import CreateAsset from "./Components/Asset/CreateAssets"
import Network from './Components/TradePair/NetWork';
import UserDepositHistory from './Components/userDepositHistory/UserDepositHistorys';
import StakingList from './Components/Staking/StakingList';
import StakingView from './Components/Staking/StakingView';
import Affliate from './Components/Affiliate_History/Affliate';
import AffliateView from './Components/Affiliate_History/AffliateView';
import StackingHistory from './Components/Staking/StackingHistory';
import CreateAdminStack from './Components/Staking/CreateAdminStack';
import EditAdminAction from './Components/Staking/EditAdminAction';
import StakingBanner from './Components/Staking/StakingBanner';
import CreateBanner from './Components/Staking/CreateBanner';
import EditBanner from './Components/Staking/EditBanners';
import UserListView from './Components/UserList/UserListView';
import Landing from './Components/Landing/Landing';


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path={`${consts.route + '/login'}`} element={<Login />} />
          <Route path='/' element={<Header />} />
          <Route path='/support' element={<Support />} />
          <Route path='/createuser' element={<CreateUser />} />
          <Route path='/alluser' element={<AllUser />} />
          <Route path='/allagent' element={<AllUser />} />
          <Route path='/players' element={<AllUser />} />
          {/* <Route path='/subscription' element={<Subscription />} /> */}
          <Route path={`${consts?.route + '/dashboard'}`} element={<Dashboard />} />

          <Route path={`${consts?.route + '/userlist'}`} element={<UserList />} />
          <Route path={`${consts?.route + '/userlistview'}`} element={<UserListView />} />

          <Route path={`${consts?.route + '/kyc'}`} element={<Kyc />} />
          <Route path={`${consts?.route + '/kycdetails'}`} element={<KycDetails />} />
          <Route path={`${consts?.route + '/userwithdrawhistry'}`} element={<UserWithdrawHistry />} />
          <Route path={`${consts?.route + '/userDepositHistry'}`} element={<UserDepositHistory />} />

          <Route path={`${consts?.route + '/asset'}`} element={<Asset />} />
          <Route path={`${consts?.route + '/createasset'}`} element={<CreateAsset />} />
          <Route path={`${consts?.route + '/tradepair'}`} element={<TradePair />} />
          <Route path={`${consts?.route + '/network'}`} element={<Network />} />

          <Route path={`${consts?.route + '/createtradepair'}`} element={<CreateTradepair />} />
          <Route path={`${consts?.route + '/subadmin'}`} element={<SubAdmin />} />

          <Route path={`${consts.route + '/stakingList'}`} element={<StakingList />} />
          <Route path={`${consts.route + '/stakingDetail'}`} element={<StakingView />} />
          <Route path={`${consts.route + '/stakingHistory'}`} element={<StackingHistory />} />
          <Route path={`${consts.route + '/createAdminStake'}`} element={<CreateAdminStack />} />
          <Route path={`${consts.route + '/editAdminStake'}`} element={<EditAdminAction />} />
          <Route path={`${consts.route + '/stakingBanner'}`} element={<StakingBanner />} />
          <Route path={`${consts.route + '/createBanner'}`} element={<CreateBanner />} />
          <Route path={`${consts.route + '/editBanner'}`} element={<EditBanner />} />

          <Route path={`${consts.route + '/affliate'}`} element={<Affliate />} />
          <Route path={`${consts.route + '/affliateview'}`} element={<AffliateView />} />

          <Route path={`${consts.route + '/createtradepair'}`} element={<CreateTradepair />} />
          <Route path={`${consts.route + '/subadmin'}`} element={<SubAdmin />} />

          <Route path={`${consts?.route + '/TradeHistory'}`} element={<TradeHistory />} />
          <Route path={`${consts?.route + '/p2pHistory'}`} element={<P2pHistory />} />
          <Route path={`${consts?.route + '/p2p'}`} element={<P2pList />} />
          <Route path={`${consts?.route + '/raisedispute'}`} element={<RaiseDispute />} />
          <Route path={`${consts?.route + '/disputedetails'}`} element={<DisputeDetails />} />
          <Route path='/landing' element={<Landing />} />

        </Routes>
      </Router>
    </div>
  );
}
export default App;
